module.exports = __webpack_public_path__ + "static/rtl-35424ab5ec175430379b262b88ab1335.gif";